/**
 * Jméno modulu core. Slouží pro jednoznačnou identifikaci modulu.
 */
export const NAME = "core";
